import { useCallback, useRef } from 'react';
import { screenToCanvas as screenToCanvasUtil } from '../types';
import { useCanvasStores, useCanvasRotation } from '../stores/CanvasContext';

/**
 * Shared hook that converts screen coordinates to canvas coordinates,
 * accounting for pan/zoom and rotation.
 */
export function useScreenToCanvas() {
  const { containerRef, panZoomStore } = useCanvasStores();
  const rotation = useCanvasRotation();
  const rotationRef = useRef(rotation);
  rotationRef.current = rotation;

  return useCallback((screenX: number, screenY: number) => {
    const container = containerRef.current;
    if (!container) return { x: 0, y: 0 };
    const pz = panZoomStore.getSnapshot().context;
    return screenToCanvasUtil(screenX, screenY, container, pz, rotationRef.current);
  }, [containerRef, panZoomStore]);
}
